
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';
import Chip from '@material-ui/core/Chip';

//Estilos
import styles from './styles-jss'
import '../../styles/components/vendors/sweetalert-react/sweetalert.css';

//Tabla
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import { Typography } from '@material-ui/core';


function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

class TableLiteraryTeam extends React.Component {
    state = {
        selected: null,
        page: 0,
        rowsPerPage: 5,
        order: 'asc',
        orderBy: 'idioma',
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    render() {

        const { headers, classes, data } = this.props;
        const { order, orderBy, rowsPerPage, page } = this.state;

        return (
            <div className={classes.ajusteTabla}>
                <Table className={classNames(classes.table, classes.stripped)}>
                    <TableHead>
                        <TableRow>
                            {headers.map((header, idx) =>
                            (
                                <TableCell key={`header_${idx}`}>{header}</TableCell>
                            ))
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {stableSort(data, getSorting(order, orderBy))
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map(item => {
                                return (
                                    <TableRow key={item.id_material_multimedia}>
                                        <TableCell className={classes.min150}>{item.version_equipo === "-1" ? item.description : item.version_equipo}</TableCell>
                                        <TableCell className={classes.max150}>
                                            <Chip label={item.value} className={getChipClassNames(classes, item.value)} />
                                        </TableCell>
                                        <TableCell>
                                            {item.equiposLiterarios.map((team, idx) => {
                                                return (
                                                    <Tooltip title={team.nombre_completo}>
                                                        <Typography 
                                                            key={`team${idx}`}
                                                            variant='body1' 
                                                            component="p" className={classNames(classes.ellipsisForever, classes.eliipsisTeam)}>
                                                                {team.nombre_completo}
                                                        </Typography>
                                                    </Tooltip>
                                                );
                                            })}
                                        </TableCell>
                                        <TableCell className={classes.min150}>
                                            {item.equiposLiterarios.map((team, idx) => {
                                                return (
                                                    <Tooltip title={team.nombre_rol}>
                                                        <Typography 
                                                            key={`team${idx}`}
                                                            variant='body1' 
                                                            component="p" className={classNames(classes.ellipsisForever, classes.eliipsisRol)}>
                                                                {team.nombre_rol}
                                                        </Typography>
                                                    </Tooltip>
                                                );
                                            })}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={data.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                        'aria-label': 'Previous Page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'Next Page',
                    }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    labelRowsPerPage={"Filas por página"}
                />
            </div>

        )
    }
}

TableLiteraryTeam.propTypes = {
    headers: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
};

export default withStyles(styles)(TableLiteraryTeam);

/**
 * Returns the corresponding color for a `Clasificacion` value.
 *  adptation -> adaptacion,
 *  original -> primigenia,
 * 
 * @param {ClassNameMap<string>>} classes 
 * @param {string} clasificacion 
 * @returns {string} Corresponding color for the `clasificacion`.
 */
function getChipClassNames(classes, clasificacion) {

    let color = null;
    let base = classes.chipBase;

    switch (clasificacion) {
        case 'Primigenia':
            base = [classes.chipTipo];
            color = classes.chipPrimigenia
            break;
        case 'Adaptación':
            base = [classes.chipTipo];
            color = classes.chipAdaptacion
            break;
        default:
            color = classes.chipDefault;
            break;
    }

    return classNames(
        base,
        color
    );
}